import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  router,
  axios,
  VueSimpleAlert,
  render: h => h(App)
}).$mount('#app')
